<template>
	<transition name="rtc-start-fade">
		<div v-if="visible" class="rtc-start-mask">
			<div class="rtc-start-card" :class="{ 'is-cancelled': state === 'cancelled' }">
				<div class="rtc-start-brand">OA IM · 安全通话</div>
				<div class="rtc-start-visual">
					<div v-if="state !== 'cancelled'" class="rtc-start-ring ring-one"></div>
					<div v-if="state !== 'cancelled'" class="rtc-start-ring ring-two"></div>
					<div class="rtc-start-icon">
						<i v-if="state === 'cancelled'" class="el-icon-close"></i>
						<i v-else :class="mode === 'voice' ? 'el-icon-phone-outline' : 'el-icon-video-camera'"></i>
					</div>
				</div>
				<div class="rtc-start-title">{{ title }}</div>
				<div class="rtc-start-detail">{{ detailText }}</div>
				<div v-if="state !== 'cancelled'" class="rtc-start-countdown">
					<span class="rtc-start-dot"></span>
					正在自动重连 · 剩余 {{ remainingSeconds }} 秒
				</div>
				<button v-if="state !== 'cancelled'" type="button" class="rtc-start-cancel" @click="$emit('cancel')">
					取消通话
				</button>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'RtcCallStarting',
	props: {
		visible: Boolean,
		state: {
			type: String,
			default: 'retrying'
		},
		remainingSeconds: {
			type: Number,
			default: 30
		},
		mode: {
			type: String,
			default: 'video'
		},
		group: Boolean,
		detail: {
			type: String,
			default: ''
		}
	},
	computed: {
		title() {
			if (this.state === 'cancelled') {
				return '通话已取消';
			}
			return this.group ? '正在恢复群聊通话' : '正在恢复通话连接';
		},
		detailText() {
			if (this.detail) {
				return this.detail;
			}
			return this.state === 'cancelled'
				? '未能连接到服务，请检查网络后重试'
				: '网络连接不稳定，正在安全地重新提交本次呼叫';
		}
	}
}
</script>

<style lang="scss" scoped>
.rtc-start-mask {
	position: fixed;
	inset: 0;
	z-index: 12000;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(20, 41, 66, 0.34);
	backdrop-filter: blur(8px);
}

.rtc-start-card {
	width: 340px;
	padding: 30px 30px 24px;
	box-sizing: border-box;
	text-align: center;
	background: linear-gradient(160deg, #ffffff 0%, #eef7ff 100%);
	border: 1px solid rgba(64, 158, 255, 0.24);
	border-radius: 24px;
	box-shadow: 0 24px 70px rgba(16, 50, 84, 0.24);
	color: #18324f;
}

.rtc-start-brand {
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 1.5px;
	color: #409eff;
}

.rtc-start-visual {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 112px;
	height: 112px;
	margin: 22px auto 16px;
}

.rtc-start-ring {
	position: absolute;
	inset: 13px;
	border: 2px solid rgba(64, 158, 255, 0.32);
	border-radius: 50%;
	animation: rtc-start-pulse 1.8s ease-out infinite;
}

.ring-two {
	animation-delay: .7s;
}

.rtc-start-icon {
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 68px;
	height: 68px;
	border-radius: 22px;
	background: linear-gradient(145deg, #5aabff, #1677ff);
	box-shadow: 0 12px 26px rgba(22, 119, 255, 0.3);
	color: #fff;
	font-size: 30px;
}

.is-cancelled .rtc-start-icon {
	background: linear-gradient(145deg, #ff7875, #e5484d);
	box-shadow: 0 12px 26px rgba(229, 72, 77, 0.24);
}

.rtc-start-title {
	font-size: 21px;
	font-weight: 700;
}

.rtc-start-detail {
	min-height: 40px;
	margin-top: 9px;
	font-size: 14px;
	line-height: 1.55;
	color: #6d86a0;
}

.rtc-start-countdown {
	display: inline-flex;
	align-items: center;
	margin-top: 13px;
	padding: 7px 12px;
	border-radius: 18px;
	background: rgba(64, 158, 255, 0.1);
	font-size: 13px;
	color: #315f8f;
}

.rtc-start-dot {
	width: 7px;
	height: 7px;
	margin-right: 7px;
	border-radius: 50%;
	background: #2f9bff;
	animation: rtc-start-dot 1s ease-in-out infinite;
}

.rtc-start-cancel {
	display: block;
	width: 100%;
	height: 40px;
	margin-top: 20px;
	border: 0;
	border-radius: 12px;
	background: #eaf3fc;
	color: #315f8f;
	cursor: pointer;
}

@keyframes rtc-start-pulse {
	0% { transform: scale(.72); opacity: .8; }
	100% { transform: scale(1.45); opacity: 0; }
}

@keyframes rtc-start-dot {
	50% { opacity: .3; }
}

.rtc-start-fade-enter-active,
.rtc-start-fade-leave-active { transition: opacity .2s ease; }
.rtc-start-fade-enter,
.rtc-start-fade-leave-to { opacity: 0; }
</style>

